import script from "./materialReport.vue?vue&type=script&setup=true&lang=js"
export * from "./materialReport.vue?vue&type=script&setup=true&lang=js"

import "./materialReport.vue?vue&type=style&index=0&id=61da4014&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61da4014"]])

export default __exports__